import { Theme, ThemedText, ThemedView } from "@app/theme";
import MoneyIcon from '../../../../assets/Icons/MoneyIcon';
import InterestRateIcon from '../../../../assets/Icons/InterestRateIcon';
import CrediLineIcon from '../../../../assets/Icons/CreditLineIcon';
import { formatIndianCurrency } from "@app/utils/utility";
import { useAppSelector } from "@app/store/hooks";
import DashedLine from "@app/sharedComponents/DashedLine/DashedLine";
import { useTheme } from "@shopify/restyle";


const ClosureLoss = () => {

    const creditDetails = useAppSelector((state) => state.auth.creditDetails);
    console.log('creditDetails',creditDetails);
    const {colors} = useTheme<Theme>();
    
    return(
        <ThemedView backgroundColor="bg-surface-primary"  borderWidth={1} borderColor="border-primary" borderRadius="lg" p="lg" mx="lg" my="lg">
            <ThemedText variant="b2s" color="text-primary">If you close your account, you will lose out on:</ThemedText>
            <ThemedView my="lg">
                <DashedLine/>
            </ThemedView>
            <ThemedView py="md" px="sm" borderColor="border-primary" borderWidth={1} flex={1} mb="lg" borderRadius="sm">
                <MoneyIcon bgColor={colors['bg-fill-emphasis-primary-1']} color1={colors['icon-action-primary']}/>
                <ThemedText variant="h2s" color="text-action-primary" my="md">₹{formatIndianCurrency(creditDetails?.actualLoanAmount)}</ThemedText>
                <ThemedText variant="b4r" color="text-primary">Instant credit limit, available immediately when you need it in emergency</ThemedText>
            </ThemedView>
            <ThemedView flexDirection="row">
                <ThemedView py="md" px="sm" borderColor="border-primary" borderWidth={1} flex={1} mr="lg" borderRadius="sm">
                    <InterestRateIcon color={colors['icon-action-primary']}/>
                    <ThemedText  variant="h2s" color="text-action-primary" my="md">{creditDetails?.currentApplicableInterestRate}%</ThemedText>
                    <ThemedText variant="b4r" color="text-primary">Competitive interest rate on credit line usage</ThemedText>
                </ThemedView>
                <ThemedView py="md" px="sm" borderColor="border-primary" borderWidth={1} flex={1}  borderRadius="sm">
                    <CrediLineIcon color={colors['icon-action-primary']}/>
                    <ThemedView flexDirection="row" alignItems="center">
                        <ThemedText  variant="l2" color="text-action-primary" my="md">₹</ThemedText>
                        <ThemedText  variant="h2s" color="text-action-primary" my="md">0</ThemedText>
                    </ThemedView>
                    <ThemedText variant="b4r" color="text-primary">Never pay interest when you're not using your credit line</ThemedText>
                </ThemedView>
            </ThemedView>

        </ThemedView>
    )
}

export default ClosureLoss;